import React, { Component } from "react";
import PropTypes from "prop-types";
import "url-search-params-polyfill";

import SearchBar from "./searchbar";
import Cards from "../cards-main";

class Search extends Component {
  constructor(props) {
    super(props);

    this.state = {
      params: {},
      originalkeyword: "",
      showMessage: false,
      searchText: "",
      categoryLabel: ""
    };

    this.setSearchParameters = this.setSearchParameters.bind(this);
    this.correctSpelling = this.correctSpelling.bind(this);
  }

  componentDidUpdate(_, prevstate) {
    if (this.state.params != prevstate.params) {
      this.setState({ showMessage: false });
      if (this.state.params.keyword || this.state.params.category) {
        this.setState({ showMessage: true });
      }
    }
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const keyword = params.get("keyword");
    const useSpellChecker = params.get("spellcheck");
    if (keyword) {
      this.setState({
        params: {
          keyword: keyword,
          useSpellChecker: useSpellChecker
        },
        searchText: keyword
      });
    }
  }

  setSearchParameters(params, categoryLabel) {
    this.setState({
      params,
      searchText: params.keyword,
      originalkeyword: null,
      categoryLabel
    });
  }

  correctSpelling(keyword) {
    this.setState({
      searchText: keyword,
      originalkeyword: this.state.params.keyword
    })
  }

  render() {
    return (
      <div className="articleSearchPage">
        <div className="articleSearchForms container">
          {this.state.showMessage && (
            <h1 className={this.state.originalkeyword ? "searchHeading searchHeadingWithAlternative" : "searchHeading"}>
              <span>Search Results for </span>
              {this.state.searchText && (
                <strong>{"'" + this.state.searchText + "'"}</strong>
              )}
              {this.state.searchText && this.state.params.category && (
                <span> & </span>
              )}
              {this.state.categoryLabel && (
                <strong>{"'" + this.state.categoryLabel + "'"}</strong>
              )}
            </h1>
          )}
          {this.state.originalkeyword && (
            <small>Search instead for <a href={window.location.href.split('?')[0] + "?keyword=" + this.state.originalkeyword + "&spellcheck=false"}>{this.state.originalkeyword}</a></small>
          )}
          <SearchBar
            api={this.props.api.categories}
            searchText={this.state.searchText}
            updateSearch={this.setSearchParameters}
          />
        </div>
        <div className="main-content">
          {Object.keys(this.state.params).length > 0 && (
            <Cards
              api={this.props.api.searchList}
              loadMore={true}
              params={this.state.params}
              correctSpelling={this.correctSpelling}
            />
          )}
        </div>
      </div>
    );
  }
}

Search.propTypes = {
  api: PropTypes.object
};

export default Search;
